export default __webpack_public_path__ + "static/media/checkbox.fb5b7b0e.svg";